import { ForecastAction, ForecastState } from 'pages/Forecast/_store';
import * as R from 'remeda';
import { timeUtility } from 'utility';

const selectedWeek = timeUtility.convertDay(
  'week',
  timeUtility.getToday(),
) as Time.Week;

const initialState: ForecastState = {
  selectedWeek,
};

const forecastReducer = (
  state: ForecastState = initialState,
  action: ForecastAction,
): ForecastState => {
  switch (action.type) {
    case 'page/forecast/SET_SELECTED_WEEK':
      return R.set(state, 'selectedWeek', action.payload);
    default:
      return state;
  }
};

export default forecastReducer;
